import {useQuery} from 'react-query';
import {getStates} from './index';
const useGetStates = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['countries'],
    queryFn: getStates,
  });
  return {statesIran: data, isLoading};
};

export default useGetStates;
